import classNames from "classnames";
import styles from "./WarningBanner.module.css";

type Props = {
  className?: string;
  message: string;
  onDismiss?: () => void;
};

export default function WarningBanner(props: Props) {
  return (
    <div className={classNames(styles.container, props.className)}>
      <div className={styles.message}>{props.message}</div>
      {props.onDismiss ? (
        <button
          className={styles.closeButton}
          onClick={() => {
            if (props.onDismiss) {
              props.onDismiss();
            }
          }}
          type="button"
        >
          x
        </button>
      ) : null}
    </div>
  );
}
